import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const Prices = ({ price , discountedPrice , id , isCentAmount  })=>{
    const { currency  } = useIntl();
    const hasDiscount = !!discountedPrice && discountedPrice !== price;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-prices"
    }, /*#__PURE__*/ React.createElement(Price, {
        id: id,
        value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : price,
        currency: currency,
        centAmount: isCentAmount,
        size: "small",
        type: hasDiscount ? 'discount' : 'default',
        "data-t": hasDiscount ? 'price-discounted' : 'price-original'
    }), hasDiscount && /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        size: "small",
        type: "strikethrough",
        "data-t": "price-original"
    }));
};

export { Prices, Prices as default };
//# sourceMappingURL=Prices.js.map
